// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"70378e6b","977":"21e72be7"}[chunkId] + ".chunk.js";
};